export default __webpack_public_path__ + "img/tab3-ab23e210.png";